import { render } from "./HomeLatestCourseList.vue?vue&type=template&id=2d13f17e&scoped=true&ts=true"
import script from "./HomeLatestCourseList.vue?vue&type=script&lang=ts"
export * from "./HomeLatestCourseList.vue?vue&type=script&lang=ts"

import "./HomeLatestCourseList.vue?vue&type=style&index=0&id=2d13f17e&scoped=true&lang=css"

import exportComponent from "/Users/uchidakouhei/workspace/docker/new-mentalnc-docker/src/new-well-labo.members.mentalnc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d13f17e"]])

export default __exports__